<template>
  <label
    v-if="label"
    class="form-label aisea-text-14-400-gray"
    :class="{ required: isRequired }"
  >
    {{ label }}
  </label>
</template>

<script>
export default {
  name: "FormLabel",
  props: {
    /**
     * ラベルテキスト
     * @type {String}
     * @required
     */
    label: {
      type: String,
      required: true,
    },
    /**
     * 必須項目かどうか
     * @type {Boolean}
     * @default false
     */
    isRequired: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/aisea/variables";

.form-label {
  display: inline-block;
  margin-bottom: 0.5rem;
  &.required::after {
    content: " *";
    color: $aisea-red;
    font-weight: 700;
  }
}
</style>
